// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"23656557","796":"3e39d3e3"}[chunkId] + ".chunk.js";
};